import { IDistrictInitialState } from "../../../types/master/districtInterface";
import { DistrictActionTypes, DistrictActions } from "../../actionTypes/master/districtActionTypes";


const initialState: IDistrictInitialState = {
  districtList: [],
  districtData: {
    id: 0,
    district_name: "",
    slug: "",
    state_code: "",
    zone_code: "",
  },
  districtListPageCount: 0,
};

export default function districtReducer(state = initialState, action: DistrictActionTypes): IDistrictInitialState {
  switch (action.type) {
    case DistrictActions.SET_DISTRICT_LIST:
      return {
        ...state,
        districtList: action.payload,
      };

    case DistrictActions.SET_DISTRICT_LIST_PAGE_COUNT:
      return {
        ...state,
        districtListPageCount: action.payload,
      };

    case DistrictActions.SET_DISTRICT_DATA_BY_ID:
      return {
        ...state,
        districtData: action.payload,
      };

    default:
      return state;
  }
}
